import { create } from "zustand";
import { persist } from "zustand/middleware";
import container from "@src/container";

const { appSettingsCache } = container;
const appSettings = appSettingsCache.get();

export const useAppStore = create(
  persist(
    (set) => ({
      lastEntryPoint: appSettings?.lastEntryPoint,
      setLastEntryPoint: (value) => {
        set((state) => {
          if (state.lastEntryPoint !== value) {
            appSettingsCache.set({ lastEntryPoint: value });
            return { lastEntryPoint: value };
          }
          return state;
        });
      },
      dashboardLoaded: false,
      setDashboardLoaded: () => set({ dashboardLoaded: true }),
      redirect: undefined,
      setRedirect: (value) => set({ redirect: value }),

      previewClassroomId: undefined,
      setPreviewClassroomId: (value) => set({ previewClassroomId: value }),
      clearPreviewClassroomId: () => set({ previewClassroomId: undefined }),
    }),
    {
      name: "app-store",
      partialize: (state) => ({
        lastEntryPoint: state.lastEntryPoint,
        previewClassroomId: state.previewClassroomId,
      }),
    }
  )
);
